import { render, staticRenderFns } from "./UnscheduledTreatment.vue?vue&type=template&id=279b4870&scoped=true"
import script from "./UnscheduledTreatment.vue?vue&type=script&lang=js"
export * from "./UnscheduledTreatment.vue?vue&type=script&lang=js"
import style0 from "./UnscheduledTreatment.scss?vue&type=style&index=0&id=279b4870&prod&lang=scss&scoped=true&external"
import style1 from "../Followups/unscheduled-treatment-page.scss?vue&type=style&index=1&id=279b4870&prod&lang=scss&scoped=true&external"
import style2 from "./UnscheduledTreatment.vue?vue&type=style&index=2&id=279b4870&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b4870",
  null
  
)

export default component.exports